<template>
  <ValidationObserver slim>
    <b-tr class="pax-form">
      <b-td :stacked-heading="$gettext('Room')" v-translate>Room {{ room }}</b-td>
      <b-td :stacked-heading="$gettext('Title')">
        <ValidationProvider
            :name="$gettext('Title')"
            :rules="{ required: true }"
            :vid="id + 'title'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-select
              size="sm"
              v-model="pax.title"
              :options="titles"
              :state="getValidationState(vContext)"
              aria-describedby="title-live-feedback"
            >
            </b-form-select>
            <b-form-invalid-feedback id="title-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
      <b-td :stacked-heading="$gettext('First name')">
        <ValidationProvider
            :name="$gettext('First name')"
            :rules="{ required: true }"
            :vid="id + 'fname'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-input
              type="text"
              :name="$gettext('First name')"
              :placeholder="$gettext('First name*')"
              class="form-control form-control-sm"
              v-model="pax.fname"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="fname-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="fname-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
            :name="$gettext('Localised First Name')"
            :rules="{ required: true }"
            :vid="id + 'local_fname'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-input
              type="text"
              :name="'prenume'"
              :placeholder="$gettext('Localised First Name') + '*'"
              class="form-control form-control-sm mt-1"
              v-model="pax.local_fname"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="local_fname-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="local_fname-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
      <b-td :stacked-heading="$gettext('Middle name')">
        <ValidationProvider
            :name="$gettext('Middle name')"
            :vid="id + 'mname'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-input
              type="text"
              :name="$gettext('Middle name')"
              :placeholder="$gettext('Middle name')"
              class="form-control form-control-sm"
              v-model="pax.mname"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="mname-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="mname-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
            :name="$gettext('Localised Middle Name')"
            :vid="id + 'local_mname'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-input
              type="text"
              :name="$gettext('Localised Middle Name')"
              :placeholder="$gettext('Localised Middle Name')"
              class="form-control form-control-sm mt-1"
              v-model="pax.local_mname"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="local_mname-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="local_mname-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
      <b-td :stacked-heading="$gettext('Last name')">
        <ValidationProvider
            :name="$gettext('Last name')"
            :rules="{ required: true }"
            :vid="id + 'lname'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-input
              type="text"
              :name="'nume'"
              :placeholder="$gettext('Last name*')"
              class="form-control form-control-sm"
              v-model="pax.lname"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="lname-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="lname-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
        <ValidationProvider
            :name="$gettext('Localised Last Name')"
            :rules="{ required: true }"
            :vid="id + 'local_lname'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-input
              type="text"
              :name="'local-name'"
              :placeholder="$gettext('Localised Last Name') + '*'"
              class="form-control form-control-sm mt-1"
              v-model="pax.local_lname"
              lang="bg"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="local_lname-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="local_lname-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
      <b-td :stacked-heading="$gettext('Age')" v-translate>{{ pax.age }}</b-td>
      <b-td :stacked-heading="$gettext('Birthday')">
        <ValidationProvider
            :name="$gettext('Birthday')"
            :rules="{ required: true, validDate: { min: from, max: to } }"
            :vid="id + 'dob'"
            v-slot="vContext"
          >
          <b-form-group>
            <DatePicker
              v-model="dob"
              :state="getValidationState(vContext)"
              :defaultValue="defaultDate"
              :notBefore="from"
              :notAfter="to"
              size="sm"
              lang="en"
              :today-label="$gettext('today')"
              :selected-date-label="$gettext('selected date')"
              placeholder="dd/mm/yyyy"
              aria-describedby="dob-live-feedback"
            ></DatePicker>
            <b-form-invalid-feedback id="dob-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
      <b-td stacked-heading="Identity document">
        <ValidationProvider
            :name="$gettext('Identity document')"
            :rules="{ required: true }"
            :vid="id + 'cnp'"
            v-slot="vContext"
          >
          <b-form-group>
            <b-form-input
              type="text"
              :name="'cnp'"
              :placeholder="$gettext('ID Number*')"
              class="form-control form-control-sm"
              v-model="pax.cnp"
              size="sm"
              :state="getValidationState(vContext)"
              aria-describedby="cnp-live-feedback"
            ></b-form-input>
            <b-form-invalid-feedback id="cnp-live-feedback">{{ vContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-td>
      <b-td stacked-heading="Seat preference" v-if="seatPreferences">
        <b-form-group>
          <b-form-select
            size="sm"
            v-model="pax.seat"
            :options="seatPreferences"
            aria-describedby="title-live-feedback"
          >
            <b-select-option :value="null">-- oricare --</b-select-option>
          </b-form-select>
        </b-form-group>
      </b-td>
      <b-td stacked-heading="Meal preference" v-if="mealPreferences">
        <b-form-group>
          <b-form-select
            size="sm"
            v-model="pax.meal"
            :options="mealPreferences"
            aria-describedby="title-live-feedback"
          >
            <b-select-option :value="null">-- oricare --</b-select-option>
          </b-form-select>
        </b-form-group>
      </b-td>
    </b-tr>
  </ValidationObserver>
</template>
<style scoped>
  fieldset {
    margin-bottom: 0px!important;
  }
</style>

<script>
import moment from 'moment'
import DatePicker from 'b2b-common/components/datepicker'
import { titles } from '@/shared/utils'
import validation from 'b2b-common/mixins/validation'

export default {
  name: 'PaxForm',
  mixins: [validation],
  props: {
    value: Object,
    room: Number,
    travelDate: Object,
    id: [String, Number],
    mealPreferences: Array,
    seatPreferences: Array,
    allowChildrenTitles: Boolean,
    maxChildAge: {
      type: Number,
      default: 18
    }
  },
  components: { DatePicker },
  data () {
    return {
      pax: this.value,
      titles: titles.map(el => ({ value: el, text: el }))
    }
  },
  computed: {
    dob: {
      get () {
        if (!this.pax.bdate) return null
        return moment(this.pax.bdate, 'DD-MM-YYYY').toDate()
      },
      set (val) {
        if (val) this.pax.bdate = moment(val).format('DD-MM-YYYY')
        else this.pax.bdate = null
      }
    },
    defaultDate () {
      if (this.pax.age === 'adult') return moment(this.travelDate).subtract(30, 'years').toDate()
      if (this.pax.age === 'child') return moment(this.travelDate).subtract((this.maxChildAge - 1), 'years').add(1, 'days').toDate()
      if (this.pax.age === 'infant') return moment(this.travelDate).subtract(1, 'years').toDate()
      return moment(this.travelDate).subtract(this.pax.age, 'years').subtract(6, 'months').toDate()
    },
    from () {
      if (this.pax.age === 'adult') return null
      if (this.pax.age === 'child') return moment(this.travelDate).subtract(this.maxChildAge, 'years').add(1, 'days').toDate()
      if (this.pax.age === 'infant') return moment(this.travelDate).subtract(2, 'years').add(1, 'days').toDate()
      return moment(this.travelDate).subtract(this.pax.age + 1, 'years').add(1, 'days').toDate()
    },
    to () {
      if (this.pax.age === 'adult') return moment(this.travelDate).subtract(this.maxChildAge, 'years').toDate()
      if (this.pax.age === 'child') return moment(this.travelDate).subtract(2, 'years').toDate()
      if (this.pax.age === 'infant') return moment(this.travelDate).toDate()
      return moment(this.travelDate).subtract(this.pax.age, 'years').toDate()
    }
  }
}
</script>
<style scoped lang="scss">
  tr.pax-form td {
    vertical-align: middle;
  }
</style>
